import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cert-custom-select-renderer',
  template: `
    <div class="d-flex align-items-center h-100">
      <ng-select
        class="full-width-select"
        appendTo="body"
        [closeOnSelect]="true"
        [multiple]="false"
        [(ngModel)]="selectedValue"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled"
        [placeholder]="placeholder"
        (change)="onValueChange($event)"
      >
        <ng-option
          *ngFor="let option of selectOptions"
          [value]="option.value"
          [disabled]="option.disabled"
          certTooltip="{{ option.label }}"
        >
          <div title="{{ option.label }}">
            {{ option.label }}
          </div>
        </ng-option>
      </ng-select>
    </div>
  `,
  styles: [
    `
      ::ng-deep ng-select {
        width: 100%;
      }
      ::ng-deep .full-width-select {
        width: 100%;
      }
      ::ng-deep .ng-select.ng-select-disabled {
        background-color: #f8f9fa;
        opacity: 0.65;
      }
    `,
  ],
  standalone: false,
})
export class CustomSelectRendererComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams<any, any>;
  selectedValue: any;
  selectOptions: CustomSelectOption[] = [];
  isDisabled = false;
  placeholder = '';

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    const rendererParams = params!.colDef!.cellRendererParams(params);
    this.selectOptions = rendererParams.selectOptions;
    this.selectedValue = rendererParams.selectedValue;
    this.isDisabled = rendererParams.disabled || false;
    this.placeholder = rendererParams.placeholder || '';
  }

  onValueChange(value: any) {
    const eventData = {
      newValue: value,
      oldValue: this.selectedValue,
      rowData: this.params.data,
    };

    this.selectedValue = value;

    const rendererParams = this.params!.colDef!.cellRendererParams(this.params);
    if (rendererParams.onValueChanged) {
      rendererParams.onValueChanged(eventData);
    }

    if (this.params.context?.customSelectChangedEvent) {
      this.params.context.customSelectChangedEvent.emit(eventData);
    }
  }

  refresh(params: any): boolean {
    const rendererParams = params!.colDef!.cellRendererParams(params);
    this.selectOptions = rendererParams.selectOptions;
    this.selectedValue = rendererParams.selectedValue;
    this.isDisabled = rendererParams.disabled || false;
    return true;
  }
}

export interface CustomSelectOption {
  label: string;
  value: any;
  disabled: boolean;
}
